import { render } from "./HomeButtonStat.vue?vue&type=template&id=f69d58e8&scoped=true"
const script = {}

import "./HomeButtonStat.vue?vue&type=style&index=0&id=f69d58e8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69d58e8"]])

export default __exports__